import React, { useCallback, useContext, useEffect, useRef } from "react";
import { isConstructorDeclaration } from "typescript";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { BasicNumericInput } from "../../common/components/generalUtilities";
import { InterviewFormContext } from "../../hooks/InterviewFormContext";
import { GoalAchievementTargetPropsShape } from "../../interfaces/componentTypes";

export const GoalAchievementTarget: React.FunctionComponent<GoalAchievementTargetPropsShape> = ({
  contextOrigin,
}) => {
  const { goalState, setGoalState } = useContext(contextOrigin);
  const { t } = useContext(TMDataContext);
  var activeCollection =
    contextOrigin == InterviewFormContext
      ? goalState.selectedInterviewSets
      : goalState.selectedEducationLinks;

  let inputId = "goal-achievement-amount-field";

  const handleValue = useCallback(
    (input) => {
      let value =
        input.target.value == "" ? null : parseInt(input.target.value);
      let maxValue = activeCollection ? activeCollection.length : 0;
      if (value && value > maxValue) {
        value = maxValue;
      }
      setGoalState((prevState) => {
        return {
          ...prevState,
          achievementTarget: value,
        };
      });
    },
    [activeCollection]
  );

  useEffect(() => {
    if (activeCollection.length == 0) {
      setGoalState((prevState) => {
        return {
          ...prevState,
          achievementTarget: null,
        };
      });
    } else {
      if (goalState.achievementTarget > activeCollection.length) {
        setGoalState((prevState) => {
          return {
            ...prevState,
            achievementTarget: activeCollection.length,
          };
        });
      }
    }
  }, [activeCollection.length]);
  return (
    <div className="goal-boxed-input-area">
      <div className="goal-form-input-row">
        <label htmlFor={inputId} className="goal-input-area-title">
          {t("views.goals.headings.goal_achieved")}
        </label>
        <div
          className="achievement-amount-input-prompt"
          style={{
            display: activeCollection.length != 0 ? "none" : "block",
          }}
        >
          {t(
            `views.goals.contexts.${goalState.type.handle}.make_selection_prompt`
          )}
        </div>
        <div
          id="achievement-amount-input-wrapper"
          style={{
            display: activeCollection.length != 0 ? "block" : "none",
          }}
        >
          <span>
            {t(
              `views.goals.contexts.${goalState.type.handle}.achievement_status_start`
            )}
          </span>{" "}
          <BasicNumericInput
            inputId={inputId}
            returnedValue={
              goalState.achievementTarget == null
                ? ""
                : goalState.achievementTarget
            }
            maxValue={activeCollection ? activeCollection.length : 0}
            minValue={1}
            handleValue={handleValue}
            className="goal-input-number-field"
          />
          <span>{t("views.goals.contexts.achievement_text_middle")}</span>{" "}
          <span className="goal-bold-highlight">
            {activeCollection ? activeCollection.length : 0}
          </span>{" "}
          <span>
            {t(
              `views.goals.contexts.${goalState.type.handle}.status_end_multiple`
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
